import React from "react";
import PropTypes from "prop-types";
import { DateTimeInput, CommonInputProps } from "react-admin";
import { RangeOutlineBox } from "../common/RangeOutlineBox";

export const DateRangeInput = (props: DateRangeInputProps) => {
  const { label, source, alwaysOn, ...rest } = props;

  return (
    <React.Fragment>
      <RangeOutlineBox label={label}>
        <DateTimeInput
          source={source + ".from"}
          label={":from"}
          {...rest}
          variant="outlined"
        />
        <div className="rangeInputSpacer">&nbsp;</div>
        <DateTimeInput
          source={source + ".to"}
          label={":to"}
          {...rest}
          variant="outlined"
        />
      </RangeOutlineBox>
    </React.Fragment>
  );
};

DateRangeInput.propTypes = {
  filter: PropTypes.object,
  label: PropTypes.string,
  source: PropTypes.string,
};

DateRangeInput.defaultProps = {
  alwaysOn: false,
};

export type DateRangeInputProps = CommonInputProps & {
  label: string;
  source: string;
};
